/**
 * @file 日付関連のリスト生成・バリデーションユーティリティ
 *
 * 生年月日の年・月・日選択リスト、クレジットカード有効期限リストの生成、
 * 生年月日の存在確認、ゼロ埋めなど、
 * フォームの日付選択プルダウンやバリデーションで使用される。
 */

/**
 * 年リストを取得する
 * ※1900～現在年
 *
 * @returns 年リスト
 */
const getBirthDateYearList = () => {
  const birthDateYearList: { key: number; value: string; label: string }[] = [];

  for (let i = new Date().getFullYear(); i >= 1900; i -= 1) {
    birthDateYearList.push({
      key: i,
      value: `${i}`,
      label: `${i}`,
    });
  }
  return birthDateYearList;
};
export { getBirthDateYearList };

/**
 * 月リストを取得する
 *
 * @returns 月リスト
 */
const getBirthDateMonthList = () => {
  const birthDateMonthList: { key: number; value: string; label: string }[] = [];

  for (let month = 1; month <= 12; month += 1) {
    birthDateMonthList.push({
      key: month,
      value: `${month}`,
      label: `${month}`,
    });
  }

  return birthDateMonthList;
};
export { getBirthDateMonthList };

/**
 * 日リストを取得する
 *
 * @param {string | undefined} year 年
 * @param {string | undefined} month 月
 * @returns 日リスト
 */
const getBirthDateDayList = (year: string | undefined, month: string | undefined) => {
  const birthDateDayList: { key: number; value: string; label: string }[] = [];
  let lastDay = new Date(Number(year), Number(month), 0).getDate();

  if (!lastDay) lastDay = 31;

  for (let i = 1; i <= lastDay; i += 1) {
    birthDateDayList.push({
      key: i,
      value: `${i}`,
      label: `${i}`,
    });
  }

  return birthDateDayList;
};
export { getBirthDateDayList };

/**
 * 生年月日が存在するかどうか
 *
 * @param {string} year 年
 * @param {string} month 月
 * @param {string} day 日
 * @returns {boolean} 生年月日が存在する場合はtrue
 */
const existsBirthDate = (
  year: string | undefined,
  month: string | undefined,
  day: string | undefined
): boolean => {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  const dt = new Date(y, m - 1, d);

  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
};
export { existsBirthDate };

/**
 * ゼロ埋めする
 *
 * @param {number} num 数値
 * @param {number} digit 桁数
 * @returns ゼロ埋めされた文字列
 */
const zeroPadding = (num: number, digit: number) => {
  return `00${num}`.slice(digit * -1);
};
export { zeroPadding };

/**
 * クレジットカード有効期限（年）リスト作成
 * @return 20年後までの有効期限（年）リスト
 */
const getCreditCardExpireYearList = () => {
  const expireYear: { key: number; value: string; label: string }[] = [];
  const currentDate: Date = new Date();
  const currentYear: number = currentDate.getFullYear();
  for (let i = 0; i < 20; i += 1) {
    expireYear.push({
      key: i,
      value: String(currentYear + i),
      label: String(currentYear + i),
    });
  }

  return expireYear;
};
export { getCreditCardExpireYearList };

/**
 * クレジットカード有効期限（月）リスト作成
 * @return ゼロ埋めの有効期限（月）リスト
 */
const getCreditCardExpireMonthList = () => {
  const expireMonth: { key: number; value: string; label: string }[] = [];

  for (let month = 1; month <= 12; month += 1) {
    expireMonth.push({
      key: month,
      value: zeroPadding(month, 2),
      label: zeroPadding(month, 2),
    });
  }

  return expireMonth;
};
export { getCreditCardExpireMonthList };
